import { render, staticRenderFns } from "./EmergingTechnology.vue?vue&type=template&id=3628c78a&scoped=true&"
import script from "./EmergingTechnology.vue?vue&type=script&lang=js&"
export * from "./EmergingTechnology.vue?vue&type=script&lang=js&"
import style0 from "./EmergingTechnology.vue?vue&type=style&index=0&id=3628c78a&lang=scss&scoped=true&"
import style1 from "./EmergingTechnology.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628c78a",
  null
  
)

export default component.exports